import { css } from '@emotion/react';
import { DesignToken } from '@livechat/design-system-react-components';

import { MEDIA_MIN_XS } from '_assets/css/breakpoints';

export const action = css`
  color: var(${DesignToken.ContentBasicPrimary});
  display: flex;
  flex-direction: column;
  text-align: right;

  ${MEDIA_MIN_XS} {
    flex-direction: row;
  }
`;

export const mobileSpan = css`
  ${MEDIA_MIN_XS} {
    display: none;
  }
`;

export const desktopSpan = css`
  display: none;

  ${MEDIA_MIN_XS} {
    display: block;
  }
`;
